import React from 'react';
import {Link} from 'react-router-dom';
import {Button} from '@chakra-ui/react';

// In general we can save loading time and keep things in the back end organized better
// by using the react-router Link for redirects.
// If you need some parameter passing and form submission useNavigation is the next best option

// Can later update this with optional styles / themes but for now works with gray buttons
const LinkButton = ({to, label}) => {
  return (
    <Button as={Link} to={to} _hover={{color: 'white', textDecoration: 'none', bg: 'secondary.600'}} colorScheme="secondary" w="100%">
      {label}
    </Button>
  );
};


export default LinkButton;
